import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/logo-horizontal.png';

const _withScopeId = n => (_pushScopeId("data-v-25572847"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  id: "header-pc"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0,
  alt: "如猫添翼"
}, null, -1));

const _hoisted_3 = {
  class: "menu"
};
const _hoisted_4 = ["href", "onClick"];

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "active-bar"
}, null, -1));

const _hoisted_6 = ["href", "onClick"];

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "active-bar"
}, null, -1));

const _hoisted_8 = ["href", "onClick"];

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "active-bar"
}, null, -1));

const _hoisted_10 = ["href", "onClick"];

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "active-bar"
}, null, -1));

const _hoisted_12 = ["href", "onClick"];

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "active-bar"
}, null, -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("ul", _hoisted_3, [_createVNode(_component_router_link, {
    to: {
      path: '/HomePage'
    },
    custom: "",
    "active-class": "link-active"
  }, {
    default: _withCtx(({
      navigate,
      href,
      isActive,
      isExactActive
    }) => [_createElementVNode("li", {
      class: _normalizeClass([isActive && 'link-active', isExactActive && 'router-link-exact-active', 'link-li'])
    }, [_createElementVNode("a", {
      class: "link",
      href: href,
      onClick: navigate
    }, "如猫添翼", 8, _hoisted_4), _hoisted_5], 2)]),
    _: 1
  }), _createVNode(_component_router_link, {
    to: {
      path: '/DemonstrationPage'
    },
    custom: "",
    "active-class": "link-active"
  }, {
    default: _withCtx(({
      navigate,
      href,
      isActive,
      isExactActive
    }) => [_createElementVNode("li", {
      class: _normalizeClass([isActive && 'link-active', isExactActive && 'router-link-exact-active', 'link-li'])
    }, [_createElementVNode("a", {
      class: "link",
      href: href,
      onClick: navigate
    }, "演示", 8, _hoisted_6), _hoisted_7], 2)]),
    _: 1
  }), _createVNode(_component_router_link, {
    to: {
      path: '/HotPersonPage'
    },
    custom: "",
    "active-class": "link-active"
  }, {
    default: _withCtx(({
      navigate,
      href,
      isActive,
      isExactActive
    }) => [_createElementVNode("li", {
      class: _normalizeClass([isActive && 'link-active', isExactActive && 'router-link-exact-active', 'link-li'])
    }, [_createElementVNode("a", {
      class: "link",
      href: href,
      onClick: navigate
    }, "如猫添翼达人端", 8, _hoisted_8), _hoisted_9], 2)]),
    _: 1
  }), _createVNode(_component_router_link, {
    to: {
      path: '/BusinessCooperationPage'
    },
    custom: "",
    "active-class": "link-active"
  }, {
    default: _withCtx(({
      navigate,
      href,
      isActive,
      isExactActive
    }) => [_createElementVNode("li", {
      class: _normalizeClass([isActive && 'link-active', isExactActive && 'router-link-exact-active', 'link-li'])
    }, [_createElementVNode("a", {
      class: "link",
      href: href,
      onClick: navigate
    }, "业务合作", 8, _hoisted_10), _hoisted_11], 2)]),
    _: 1
  }), _createVNode(_component_router_link, {
    to: {
      path: '/JoinUsPage'
    },
    custom: "",
    "active-class": "link-active"
  }, {
    default: _withCtx(({
      navigate,
      href,
      isActive,
      isExactActive
    }) => [_createElementVNode("li", {
      class: _normalizeClass([isActive && 'link-active', isExactActive && 'router-link-exact-active', 'link-li'])
    }, [_createElementVNode("a", {
      class: "link",
      href: href,
      onClick: navigate
    }, "加入我们", 8, _hoisted_12), _hoisted_13], 2)]),
    _: 1
  })])]);
}